import React from 'react';

import { hotspotMapMessages } from '../../../../../translates/hotspotMapMessages';
import { useIntlReexport } from '../../../../hooks/useIntlReexport';
import { ToastNotification } from '@ael/shared-components-library';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';

interface HotspotMapRemainingToastProps {
  count: number;
}

export const HotspotMapRemainingToast: React.FC<HotspotMapRemainingToastProps> = ({ count }) => {
  const { formatMessage } = useIntlReexport();
  return (
    <ToastNotification
      title={
        count === 0
          ? formatMessage(hotspotMapMessages.nextScrene)
          : formatMessage(hotspotMapMessages.hotspotsRemaining, {
              count: count,
            })
      }
      icon={regular('location-dot')}
      hideCloseButton={true}
      variant="warning"
      darkMode={true}
      visible={true}
    />
  );
};
